export default "__VITE_ASSET__D09IeL7E__"